import {
  ClauseCheckDetailType,
  ParentDetailsType,
} from "../vscDashboard/types";

export class ContractTableData {
  count: number;
  next: any;
  previous: any;
  results: ContractTableEntity[];

  constructor(obj: any) {
    this.count = obj?.count;
    this.next = obj?.next;
    this.previous = obj?.previous;
    this.results = obj?.results?.map(
      (item: any) => new ContractTableEntity(item)
    );
  }
}
export class ContractTableEntity {
  [key: string]: any;
  file: string;
  id: string;
  vendorName: string;
  contractId: string;
  contractType: string;
  serviceType: string;
  startDate: string;
  endDate: string;
  mtc: string;
  title: string;

  constructor(obj: any) {
    this.file = obj?.name;
    this.id = obj?.id;
    this.vendorName = obj?.doc_meta?.vendor_name;
    this.contractId = obj?.doc_meta?.contract_id;
    this.contractType = obj?.doc_meta?.contract_type;
    this.serviceType = obj?.doc_meta?.service_type;
    this.startDate = obj?.doc_meta?.start_date;
    this.endDate = obj?.doc_meta?.end_date;
    // this.mtc = obj?.doc_meta?.maximum_total_cost;
    this.mtc = `$${
      obj?.doc_meta?.maximum_total_cost === "N/A" ||
      !obj?.doc_meta?.maximum_total_cost ||
      isNaN(obj?.doc_meta?.maximum_total_cost) ||
      !isFinite(obj?.doc_meta?.maximum_total_cost)  
        ? "0"
        : obj?.doc_meta?.maximum_total_cost
    }`;
    this.title = obj?.doc_meta?.title;
  }
}

export class BulkClauseTableEntity {
  [key: string]: any;
  vendorName: string;
  engagementName: string;
  contractId: string;
  simbaId: string;
  documentId: string;
  vertical: string;
  serviceType: string;
  id: string;
  status: string;
  startDate: string;
  endDate: string;
  mtc: string;
  displayName: string;
  title: string;
  vendorWithType: {
    vendor: string;
    docType: string;
  };

  constructor(obj: any) {
    this.id = obj?.id;
    this.displayName = obj?.display_name;
    this.status = obj?.status;
    this.vendorName = obj?.clause_meta?.vendor_name || obj?.display_name;
    this.title = obj?.clause_meta?.title;
    this.engagementName =
      obj?.clause_meta?.engagement_name || obj?.clause_meta?.contract_type;
    this.contractId = obj?.clause_meta?.contract_id;
    this.simbaId = obj?.clause_meta?.simba_id;
    this.documentId = obj?.clause_meta?.document_id;
    this.vertical = obj?.clause_meta?.vertical;
    this.serviceType = obj?.clause_meta?.service_type;
    this.startDate = obj?.clause_meta?.start_date || "NA";
    this.endDate = obj?.clause_meta?.end_date || "NA";
    const mtc = obj?.clause_meta?.maximum_total_cost;
    this.mtc =
      mtc && isFinite(mtc) && !isNaN(mtc)
        ? `$${Number(mtc).toLocaleString()}`
        : "NA";
    this.vendorWithType = {
      vendor: this.vendorName,
      docType: this.engagementName,
    };
  }
}

export class BulkClauseTableData {
  count: number;
  results: BulkClauseTableEntity[];
  next: any;
  previous: any;

  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.results = obj?.results?.map(
      (res: any) => new BulkClauseTableEntity(res)
    );
    this.next = obj?.next;
    this.previous = obj?.previous;
  }
}

export class BulkSummaryTableEntity {
  [key: string]: any;
  vendorName: string;
  engagementName: string;
  earnBack: {};
  volumeDiscount: {};
  investments: {};
  prodImprove: {};
  benchRecommendation: {};
  overtime: {};
  contractId: string;
  simbaId: string;
  documentId: string;
  title: string;
  id: string;
  vendorWithType: {
    vendor: string;
    docType: string;
  };
  clauseCheckDetails: {};
  is_parent_present: boolean;
  parent_details?: ParentDetailsType;
  clause_check_details: ClauseCheckDetailType[];
  constructor(obj: any) {
    this.vendorName = obj?.metadata?.vendor_name;
    this.id = obj?.id;
    this.title = obj?.metadata?.title;
    this.clauseCheckDetails = obj?.clause_check_details?.reduce(
      (acc: any, el: any) => {
        return { ...acc, [el?.category]: el };
      },
      {}
    );
    this.is_parent_present = obj?.is_parent_present;
    this.parent_details = obj.parent_details
      ? {
          id: obj.parent_details.id,
          display_name: obj.parent_details.display_name,
          metadata: obj.parent_details.metadata,
          clause_check_details: obj.parent_details.clause_check_details,
        }
      : undefined;
    this.clause_check_details = obj.clause_check_details;
    this.engagementName =
      obj?.metadata?.engagement_name || obj?.metadata?.contract_type;
    this.contractId = obj?.metadata?.contract_id;
    this.simbaId = obj?.metadata?.simba_id;
    this.documentId = obj?.metadata?.document_id;
    this.earnBack = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "SLA Penalties/Earn Back"
    )[0];
    this.volumeDiscount = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Volume Discounts"
    )[0];
    this.investments = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Non-EPP Investments"
    )[0];
    this.prodImprove = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Productivity Improvements"
    )[0];
    this.benchRecommendation = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Committed Buffer/Bench Pool"
    )[0];
    this.overtime = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Overtime/On-call & Holiday Bill Rates"
    )[0];
    this.vendorWithType = {
      vendor: this.vendorName,
      docType: this.engagementName,
    };
  }
}

export class BulkSummaryTableData {
  count: number;
  results: BulkSummaryTableEntity[];
  next: any;
  previous: any;

  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.results = obj?.results?.map(
      (res: any) => new BulkSummaryTableEntity(res)
    );
    this.next = obj?.next;
    this.previous = obj?.previous;
  }
}

class UserManagementTableEntity {
  name: string;
  userId: string;
  roles: any;
  action: any;

  constructor(obj: any) {
    this.name = obj?.name;
    this.userId = obj?.userId;
    this.roles = obj?.roles;
    this.action = obj?.action;
  }
}
export class UserManagementTable {
  count: number;
  results: UserManagementTableEntity[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count;
    this.results = obj?.results?.map(
      (res: any) => new UserManagementTableEntity(res)
    );
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

export class DraftingTableData {
  count: number;
  next: any;
  previous: any;
  results: DraftingTableEntity[];

  constructor(obj: any) {
    this.count = obj?.count;
    this.next = obj?.next;
    this.previous = obj?.previous;
    this.results = obj?.results?.map(
      (item: any) => new DraftingTableEntity(item)
    );
  }
}

export class DraftingTableEntity {
  [key: string]: any;
  id: string;
  uploadedBy: string;
  contractFileName: string;
  templateMappingId: string;
  driveId: string;
  inputTermSheetGcsLoc: string;
  vendorNameMetadata: string;
  contractNameMetadata: string;
  createdAt: string;
  updatedAt: string;
  termsheet: string;
  templateType: string;

  constructor(obj: any) {
    this.id = obj?.id;
    this.uploadedBy = obj?.uploaded_by;
    this.contractFileName = obj?.contract_file_name;
    this.templateMappingId = obj?.template_mapping_id;
    this.driveId = obj?.drive_id;
    this.inputTermSheetGcsLoc = obj?.input_term_sheet_gcs_loc;
    this.vendorNameMetadata = obj?.vendor_name_metadata;
    this.contractNameMetadata = obj?.contract_name_metadata;
    this.createdAt = obj?.created_at;
    this.updatedAt = obj?.updated_at;
    this.termsheet = obj?.termsheet;
    this.templateType = obj?.template_type;
  }
}
export class RfxEvaluationTableData {
  count: number;
  next: any;
  previous: any;
  results: RfxEvaluationTableEntity[];

  constructor(obj: any) {
    this.count = obj?.count;
    this.next = obj?.next;
    this.previous = obj?.previous;
    this.results = obj?.results?.map(
      (item: any) => new RfxEvaluationTableEntity(item)
    );
  }
}

export class RfxEvaluationTableEntity {
  id: string;
  uploadedBy: string;
  rfxFileName: string;
  rfxGcsLoc: string;
  rfxDriveLoc: string;
  countOfRfxResponse: string;
  productAreaName: string;
  topAgency: string;
  createdAt: string;
  updatedAt: string;
  date: string;
  time: string;
  dateAndTime: {
    date: string;
    time: string;
  };

  constructor(obj: any) {
    this.id = obj?.id;
    this.uploadedBy = obj?.uploaded_by;
    this.rfxFileName = obj?.rfx_file_name;
    this.rfxGcsLoc = obj?.rfx_gcs_loc;
    this.rfxDriveLoc = obj?.rfx_drive_loc;
    this.countOfRfxResponse = obj?.count_of_rfx_response;
    this.productAreaName = obj?.product_area_name;
    this.topAgency = obj?.top_agency;
    this.createdAt = obj?.created_at;
    this.updatedAt = obj?.updated_at;
    this.date = obj?.date;
    this.time = obj?.time;
    this.dateAndTime = {
      date: obj?.date_and_time?.date,
      time: obj?.date_and_time?.time,
    };
  }
}

export class GeneratedRfxTableEntity {
  [key: string]: any;
  id: string;
  uploadedById: string;
  rfxFileName: string;
  rfxNameMetadata: string;
  outputFileDriveId: string;
  outputFileDriveLoc: string;
  outputFileGcsLoc: string;
  rfxTemplateMappingId: string;
  inputIntakeFormGcsLoc: string;
  productAreaMetadata: string;
  contractNameMetdata: string;
  createdBy: string;
  updatedAt: string;
  intakeFormTemplateName: string;
  dateAndTime: {
    date: string;
    time: string;
  };
  rfxTemplateName: string;

  constructor(obj: any) {
    this.id = obj?.id;
    this.uploadedById = obj?.uploaded_by_id;
    this.rfxFileName = obj?.rfx_file_name;
    this.rfxNameMetadata = obj?.rfx_name_metadata;
    this.outputFileDriveId = obj?.output_file_drive_id;
    this.outputFileDriveLoc = obj?.output_file_drive_loc;
    this.outputFileGcsLoc = obj?.output_file_gcs_loc;
    this.rfxTemplateMappingId = obj?.rfx_template_mapping_id;
    this.inputIntakeFormGcsLoc = obj?.input_intake_form_gcs_loc;
    this.productAreaMetadata = obj?.product_area_metadata;
    this.contractNameMetdata = obj?.contract_name_metdata;
    this.createdBy = obj?.created_by;
    this.updatedAt = obj?.updated_at;
    this.intakeFormTemplateName = obj?.intake_form_template_name;
    this.dateAndTime = {
      date: obj?.date_and_time?.date,
      time: obj?.date_and_time?.time,
    };
    this.rfxTemplateName = obj?.rfx_template_name;
  }
}

export class GeneratedRfxTableData {
  count: number;
  next: string | null;
  previous: string | null;
  results: GeneratedRfxTableEntity[];

  constructor(data: any) {
    this.count = data?.count || 0;
    this.next = data?.next || null;
    this.previous = data?.previous || null;
    this.results =
      data?.results?.map((item: any) => new GeneratedRfxTableEntity(item)) ||
      [];
  }
}

export class WorkBenchTableEntity {
  [key: string]: any;
  request: string;
  budget: string;
  categorymanager: string;
  status: string;
  showDelayedMessage?: boolean;
  document_drive_link?: string;
  document_gcs_path?: string;
  doc_id?: string;
  request_number?: string;
  document_name?: string;

  constructor(obj: any) {
    // API returns fields like request_name, request_number, sourcing_request_title
    this.request = obj?.request_name || obj?.sourcing_request_title || obj?.request || "N/A";
    this.request_number = obj?.request_number || obj?.request_no || "N/A";
    
    // Extract first document info
    const firstDoc = obj?.documents && obj.documents.length > 0 ? obj.documents[0] : null;
    
    // Budget comes from documents array, format it with $ if present
    const budgetValue = firstDoc?.budget || obj?.budget;
    if (budgetValue && budgetValue !== "N/A") {
      // Check if budget already has $ prefix
      this.budget = budgetValue.startsWith('$') ? budgetValue : `$${budgetValue}`;
    } else {
      this.budget = "N/A";
    }
    
    // category manager field may be named category_manager_name in API
    this.categorymanager = obj?.category_manager_name || obj?.categorymanager || "N/A";
    
    // Use ROW-LEVEL status (not document status) - this is the sourcing request status
    this.status = obj?.status || "N/A";
    this.showDelayedMessage = obj?.showDelayedMessage;
    this.document_drive_link = obj?.document_drive_link || null;
    this.document_gcs_path = obj?.document_gcs_path || null;
    this.document_name = obj?.document_name || "N/A";

    // extract doc_id from documents array if present
    this.doc_id = obj?.doc_id || firstDoc?.id || null;
  }
}

export class WorkBenchTableData {
  count: number;
  next: string | null;
  previous: string | null;
  results: WorkBenchTableEntity[];

  constructor(data: any) {
    this.count = data?.count || 0;
    this.next = data?.next || null;
    this.previous = data?.previous || null;
    this.results =
      data?.results?.map((item: any) => new WorkBenchTableEntity(item)) || [];
  }
}
